import * as React from "react";
import { Tab, TabBar, TabSize } from "azure-devops-ui/Tabs";
import { Header, TitleSize } from "azure-devops-ui/Header";
import { IHeaderCommandBarItem } from "azure-devops-ui/HeaderCommandBar";
import { Page } from "azure-devops-ui/Page";
import { FilterBar } from "azure-devops-ui/FilterBar";
import {
    InlineKeywordFilterBarItem,
    KeywordFilterBarItem
} from "azure-devops-ui/TextFilterBarItem";
import { IFilter, Filter } from "azure-devops-ui/Utilities/Filter";
import { DropdownSelection } from "azure-devops-ui/Utilities/DropdownSelection";
import { DropdownFilterBarItem } from "azure-devops-ui/Dropdown";

import "./Page.Example.css";

interface IPageWithTabBarExampleState {
    selectedTabId: string;
}

const commandBarItemsFor1: IHeaderCommandBarItem[] = [
    {
        id: "create",
        text: "Create Project",
        onActivate: () => {
            alert("Create project");
        },
        iconProps: {
            iconName: "Add"
        },
        isPrimary: true
    }
];

const commandBarItemsFor2 = [
    ...commandBarItemsFor1,
    {
        id: "otherAction",
        text: "Action",
        onActivate: () => {
            alert("Action 2");
        }
    }
];

export default class PageWithTabBarExample extends React.Component<
    {},
    IPageWithTabBarExampleState
> {
    private filter: IFilter;

    constructor(props: {}) {
        super(props);
        this.state = {
            selectedTabId: "tab2"
        };
        this.filter = new Filter();
    }

    public render() {
        let commandBarItems = undefined;
        if (this.state.selectedTabId === "tab1") {
            commandBarItems = commandBarItemsFor1;
        } else if (this.state.selectedTabId === "tab2") {
            commandBarItems = commandBarItemsFor2;
        }
        return (
            <Page className="sample-page flex-grow">
                <Header
                    title="Page Title"
                    titleSize={TitleSize.Large}
                    commandBarItems={commandBarItems}
                />
                <TabBar
                    onSelectedTabChanged={this.onSelectedTabChanged}
                    selectedTabId={this.state.selectedTabId}
                    tabSize={TabSize.Tall}
                    renderAdditionalContent={this.renderFilterBarInTabBar}
                >
                    <Tab name="Tab 1" id="tab1" />
                    <Tab name="Tab 2" id="tab2" />
                    <Tab name="Tab 3" id="tab3" />
                </TabBar>
                {this.renderFilterBarInContent()}
                {this.getPageContent()}
            </Page>
        );
    }

    private onSelectedTabChanged = (newTabId: string) => {
        this.setState({
            selectedTabId: newTabId
        });
    };

    private renderFilterBarInTabBar = () => {
        if (this.state.selectedTabId === "tab1") {
            return <InlineKeywordFilterBarItem filter={this.filter} filterItemKey="keyword" />;
        }
        return undefined;
    };

    private renderFilterBarInContent = () => {
        if (this.state.selectedTabId === "tab3") {
            return (
                <FilterBar filter={this.filter}>
                    <KeywordFilterBarItem filterItemKey="keyword" />
                    <DropdownFilterBarItem
                        filterItemKey="picklist"
                        filter={this.filter}
                        items={[{ id: "Item 1", text: "Item 1" }, { id: "Item 2", text: "Item 2" }]}
                        selection={new DropdownSelection()}
                        placeholder="Dropdown"
                    />
                </FilterBar>
            );
        }
        return null;
    };

    private getPageContent() {
        const { selectedTabId } = this.state;
        if (selectedTabId === "tab1") {
            return <div className={"page-content"}> Tab 1</div>;
        } else if (selectedTabId === "tab2") {
            return <div className={"page-content"}> Tab 2</div>;
        } else if (selectedTabId === "tab3") {
            return <div className={"page-content"}> Tab 3</div>;
        }
        return null;
    }
}
